import { useMemo } from 'react';
import Typography from '@material-ui/core/Typography';
import cx from 'classnames';
import PropTypes from 'prop-types';

import ContentSimple from '../ContentSimple';

import useStyles from './useStyles';

export const ContentOutline = ({ className, content, withInstructions }) => {
  const styles = useStyles();

  const rows = useMemo(
    () =>
      content.map(({ id, headline, instructions }, i) => ({
        id,
        title: `Section ${i + 1}`,
        value: headline,
        instructions,
      })),
    [content]
  );

  return (
    <div className={cx(styles.root, { [styles.withInstructions]: withInstructions }, className)}>
      {rows.map((row) => (
        <div
          key={row.id}
          className={cx({ [styles.withInstructionsRowWrapper]: withInstructions })}
        >
          <div className={cx(styles.row, { [styles.withInstructions]: withInstructions })}>
            <Typography className={styles.title}>{row.title}</Typography>
            <ContentSimple
              className={styles.content}
              content={row.value}
            />
          </div>

          {withInstructions && (
            <Typography className={styles.instructions}>{row.instructions}</Typography>
          )}
        </div>
      ))}
    </div>
  );
};

ContentOutline.propTypes = {
  className: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
  withInstructions: PropTypes.bool,
};

ContentOutline.defaultProps = {
  className: null,
  withInstructions: false,
};
